const YesNoNode = require('../YesNoNode');
const Q_which_stance = require('./Q_which_stance');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_faux_selves = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.fauxSelfAbility = BattleCalc.getEquippedAbility(actor, 'faux_self');

  node.branches[node.YES] = new Q_which_stance(actor, battleState);

  if (node.fauxSelfAbility) {
    node.branches[node.NO] = new UseAbility(actor, 'faux_self', actor);
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function () {
    if (!node.fauxSelfAbility) {
      return true;
    }

    for (const unit of BattleCalc.getAlliesOfUnit(
      this.actor,
      this.battleState.allUnits,
      false
    )) {
      if (
        unit.faux_self &&
        unit.ownerId === this.actor.uid &&
        unit.inPlay &&
        !unit.dead
      ) {
        return true;
      }
    }

    return false;
  };

  return node;
};
module.exports = Q_faux_selves;
